// extracted by mini-css-extract-plugin
export default {"control":"control_control__4VwEo","button":"control_button__QdbiK"};